export default [
  {
    path: '/activity-20260601-main',
    component: () => import('./Page.vue'),
    meta: { title: '61童梦游乐园', id: 31 },
  },
  {
    path: '/activity-20260601-rule',
    component: () => import('./Rule.vue'),
    meta: { title: '61童梦游乐园-规则', id: 31 },
  },
]
